module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//house-monster.png?v=625c58bf";